export const SERVER_ENVIRONMENT_META_NAME = 'pplx-server-environment';
export function normalizeServerEnvironment(value) {
    switch (value?.toLowerCase()) {
        case 'prod_single_tenant':
        case 'single-tenant':
            return 'single-tenant';
        case 'dev':
        case 'development':
        case 'local':
            return 'local';
        case 'preview':
            return 'preview';
        case 'beta':
        case 'prod':
        case 'production':
            return 'production';
        case 'stg':
        case 'staging':
        case 'staging-old':
            return 'staging';
        case 'test':
        case 'testing':
            return 'testing';
        default:
            return undefined;
    }
}
export function isStagingServerEnvironment(value) {
    return normalizeServerEnvironment(value) === 'staging';
}
//# sourceMappingURL=serverEnvironment.js.map